const sourceMap = {
  tpi: "https://player.vimeo.com/video/831298106?h=71c4c68c58&autoplay=1",
  mmb: "https://player.vimeo.com/video/964752254?h=3d06214e4e&autoplay=1",
  calibr: "https://player.vimeo.com/video/841462245?h=a2d720636d&autoplay=1",
  lvf: "https://player.vimeo.com/video/841463139?h=5deb0572e0&autoplay=1",
  uncf: "https://player.vimeo.com/video/841463944?h=5692ed7e94&autoplay=1",
  wgu: "https://player.vimeo.com/video/1046542744?h=f64bf15feb&autoplay=1",
};

function isKeyofSourceMap(key?: string): key is keyof typeof sourceMap {
  return !!key && key in sourceMap;
}

const buttons = document.querySelectorAll("button");

buttons.forEach((button) => {
  button.addEventListener("click", (event) => {
    const key = (event.currentTarget as HTMLButtonElement).dataset.videoKey;
    if (isKeyofSourceMap(key)) replaceVideo(sourceMap[key]);
  });
});

function replaceVideo(nextSource: string) {
  const iframe = document.querySelector("iframe") as HTMLIFrameElement;
  iframe.src = nextSource;
}
